import { URL_REGEX } from '@/core/lib/regex';

export const hasNotUrl = (description?: string): boolean => {
  if (description) {
    return !URL_REGEX.test(description);
  }
  return true;
};
